import React, {
  FunctionComponent,
  CSSProperties,
  useState,
} from "react";
import {
  FormGroupContainer,
  FormContainer,
  Label,
  LabelValue,
  InputText,
  InputTextArea,
  InputSelect,
  InputCheckbox,
  FileButton,
  ImageContainer,
  Image,
  LabelError,
  FormErrorContainer,
} from "./styled.components";
import { AnyIfEmpty, useSelector } from "react-redux";
import Icon from "@mui/material/Icon";

type InputsProps = {
  id?: string;
  label?: string;
  type: string;
  value?: any;
  options?: any;
  accept?: string;
  disable?: boolean;
  visible?: boolean;
  placeholder?: string;
  className?: any;
  labelPercent?: number;
  errorMessage?: string;
  handleOnChange?: (e: any) => void;
  maxLength?: number;
  onKeyPress?: (e: any) => void;
};

const Inputs: FunctionComponent<InputsProps> = ({
  id,
  label,
  type,
  value,
  options,
  accept,
  disable = false,
  visible = true,
  placeholder,
  className,
  labelPercent,
  errorMessage,
  handleOnChange,
  maxLength,
  onKeyPress,
}) => {
  const styles: CSSProperties = {
    fontSize: `clamp(0.6rem, 2.5vw, 1rem)`,
    color: "#ffffff",
  };
  const { inputTheme } = useSelector((state: any) => state.theme);
  const handleRenderOptions = (item: any) => {
    return (
      <option key={"option_" + item.value} value={item.value}>
        {item.text}
      </option>
    );
  };

  const [stateFile, setStateFile] = useState<any>();

  const handleRenderInput = () => {
    label += label == "" ? "" : ":";

    switch (type) {
      case "select":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
              <InputSelect
                id={id}
                value={value}
                disabled={disable}
                onChange={handleOnChange}
                className={className}
                widthPercentage={labelPercent ? labelPercent : 25}
              >
                {options.map(handleRenderOptions)}
              </InputSelect>
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      case "password":
      case "text":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
              <InputText
                id={id}
                type={type}
                value={value}
                disabled={disable}
                placeholder={placeholder}
                onChange={handleOnChange}
                className={className}
                widthPercentage={labelPercent ? labelPercent : 25}
                maxLength={maxLength}
              />
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      case "textarea":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
              <InputTextArea
                id={id}
                value={value}
                disabled={disable}
                placeholder={placeholder}
                onChange={handleOnChange}
                rows={3}
                className={className}
                widthPercentage={labelPercent ? labelPercent : 25}
              />
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      case "number":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
              <InputText
                id={id}
                type={type}
                value={value}
                disabled={disable}
                placeholder={placeholder}
                onChange={handleOnChange}
                className={className}
                widthPercentage={labelPercent ? labelPercent : 25}
              />
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      case "date":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
              <InputText
                id={id}
                type={type}
                value={value}
                disabled={disable}
                placeholder={placeholder}
                onChange={handleOnChange}
                className={className}
                widthPercentage={labelPercent ? labelPercent : 25}
              />
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      case "file":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
              <input
                type="file"
                hidden
                id="_inputFile"
                accept={accept}
                onChange={(e) => {
                  if (!e) return null;
                  //@ts-ignore
                  handleOnChange(e);
                  //@ts-ignore
                  setStateFile(e.target.files[0]);
                }}
              />
              <InputText
                id={id}
                type={"text"}
                value={stateFile ? stateFile.name : ""}
                disabled={disable}
                placeholder={placeholder}
                className={className}
                widthPercentage={labelPercent ? labelPercent + 5 : 2}
              />
              <FileButton htmlFor="_inputFile">
                <Icon
                  style={{ color: styles.color, fontSize: styles.fontSize }}
                >
                  attach_file
                </Icon>
              </FileButton>
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      case "switch":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      case "checkbox":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
              <InputCheckbox
                id={id}
                type={type}
                value={value}
                disabled={disable}
                onChange={handleOnChange}
                className={className}
              />
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      case "checklist":
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
      default:
        return (
          <FormErrorContainer visible={visible}>
            <FormContainer>
              <Label widthPercentage={labelPercent ? labelPercent : 25}>
                {label}
              </Label>
            </FormContainer>
            <LabelError textColor={inputTheme?.textColor || "red"}>{`${
              errorMessage ? "* " + errorMessage : ""
            }`}</LabelError>
          </FormErrorContainer>
        );
        break;
    }
  };

  return <>{handleRenderInput()}</>;
};

type InputsGroupProps = {
  visible?: boolean;
  children?: React.ReactNode;
  pTB?: any;
  jC?: string;
};

export const InputsGroup: FunctionComponent<InputsGroupProps> = ({
  children,
  visible = true,
  pTB,
  jC
}: any) => {
  const { catalogs } = useSelector((state: any) => state.theme);

  return (
    <FormGroupContainer visible={visible} bg={catalogs?.context} pTB={pTB} jC={jC}>
      {children}
    </FormGroupContainer>
  );
};

type InputsLabelProps = {
  label?: string;
  value?: any;
  visible?: boolean;
  labelPercent?: number;
};

export const InputLabel: FunctionComponent<InputsLabelProps> = ({
  label,
  value,
  visible = true,
  labelPercent,
}) => {
  return (
    <FormErrorContainer visible={visible}>
      <FormContainer>
        <Label widthPercentage={labelPercent ? labelPercent : 25}>
          {label}
        </Label>
        <LabelValue widthPercentage={labelPercent ? labelPercent + 5 : 2}>
          {value}
        </LabelValue>
      </FormContainer>
    </FormErrorContainer>
  );
};

type InputsImageProps = {
  id?: string;
  label?: string;
  value?: any;
  visible?: boolean;
  labelPercent?: number;
};

export const InputImage: FunctionComponent<InputsImageProps> = ({
  id,
  label,
  value,
  visible = true,
  labelPercent,
}) => {
  return (
    <FormErrorContainer visible={visible}>
      <FormContainer>
        <Label widthPercentage={labelPercent ? labelPercent : 25}>
          {label}
        </Label>
        <ImageContainer widthPercentage={labelPercent ? labelPercent + 5 : 2}>
          <Image id={id} src={value} />
        </ImageContainer>
      </FormContainer>
    </FormErrorContainer>
  );
};

export default Inputs;
